import React, { memo, useState, useRef } from 'react';
import { Modal, List, Button, Icon, Progress, message, Upload } from 'antd';
import {  ChunkUpload, request, FileCountLimiter } from '@cm-sites-webber/components';

const  BatchEntry = (props) => {

    const [visible,setVisible] = useState(false);
    const [filesList,setFilesList] = useState([]);
    const uploadRef = useRef();
    const fileType = ["doc","docx"];

    // 创建上传切片
    const chunkUpload = new ChunkUpload({
        checkFileURL:"/storage/checkFile",
        checkChunkURL:"/storage/checkChunk",
        uploadChunkURL:"/storage/uploadChunk",
        chunkUploadOverURL:"/storage/chunkIsUploadOver",
        mergeChunksURL:"/storage/mergeChunk",
        limiter: (()=>{
            return new FileCountLimiter(5)
        })()
    })

    const renderModal = (
        <Modal
            title="批量录入"
            visible={visible}
            onCancel={()=>close()}
            okText="确定录入"
            cancelText="关闭"
            keyboard={false}
            onOk={()=>{
                batchImport({code:props.data?.code,wordJsonObjectList:filesList.map(item=>({...item.response}))})
            }}
            destroyOnClose
            maskClosable={false}
            width={800}
            afterClose={()=>{
                chunkUpload.cancelUploadAll();
                setFilesList([]);
            }}
        >
            <div id='batchEntryContent'>
                <List
                    dataSource={[...filesList]}
                    renderItem={(item,index)=>{
                        const errorColor = "#f56c6c"
                        const { status } = item;
                        const isError = status === "error";
                        const title = item.url || isError ?
                            item.name :
                            (item.ingStatus ? item.ingStatus : "加载中，请稍后...");
                        const progressShow =  (item.status&&item.status ==="done"&& !!item.url) ? "none" : "";
                        return (
                            <List.Item key={item.uid} style={{ width: "100%",flexGrow: 1}}>
                                <div style={{ display: "inline-flex", flexWrap: "nowrap", width: "100%" }}>
                                    <Icon type="link" style={{marginTop: 5}} />
                                    <div style={{marginLeft: "5px", flex:2}}>
                                        <div style={{display: "inline-flex",width: "100%"}}>
                                            <span title={item.name} style={{flexGrow:1,textOverflow: "ellipsis",overflow: "hidden",whiteSpace: "nowrap",width: "360px"}}>{title}</span>
                                            {
                                                item.status&&item.status === "uploading"&&<Icon type="close" style={{marginTop: 5,cursor: "pointer"}} onClick={()=>{fileCancel(item)}} />
                                            }
                                            {
                                                ((item.status&&item.status === "done")&&item.url) && <span style={{color: "red",cursor: "pointer"}} onClick={()=>{fileDelete(item)}}>删除</span>
                                            }
                                        </div>
                                        <Progress style={{display: progressShow}}  strokeColor={isError ? errorColor : ""} status={isError ? "exception" : item.url ? "success" : "active"} percent={item.url?100:parseInt(item.percent)} showInfo={false} />
                                    </div>
                                </div>
                            </List.Item>
                        )
                    }}
                />
                <div>
                    <Button type="dashed" block icon='plus' onClick={()=>uploadRef.current.click()}>添加</Button>
                </div>
                <Upload
                    multiple={true}
                    accept={".doc,.docx"}
                    fileList={filesList}
                    beforeUpload={(file)=>{
                        if (filesList.some(item=>item.name === file.name && item.size === file.size)) {
                            message.warning("当前文件重复上传");
                            return Promise.reject("当前文件重复上传");
                        }
                        if (file.size === 0) {
                            message.warning("不允许上传空文件");
                            return Promise.reject("不允许上传空文件");
                        }
                        if (!fileType.some(item=>file.name.endsWith(item))) {
                            message.warning("不支持当前格式的文件");
                            return Promise.reject("不支持当前格式的文件");
                        }
                        return Promise.resolve(file)
                    }}
                    showUploadList={false}
                    customRequest={chunkUpload.start}
                    onChange={({file,fileList})=>{
                        // let fileListTemp = [...fileList];
                        console.log(fileList)
                        let fileListTemp = fileList.map(item=>{
                            console.log(item);
                            return {
                                ...item,
                                uid: item.uid,
                                response: {...item.response?.data, ...item.response,data:item.response?.data},
                                ext:  item.response?.data ? item.response.data.suffix : item.response?.suffix,
                                url : item.response?.data ? item.response.data.path : item.response?.path,
                                path :item.response?.data ? item.response.data.path : item.response?.path,
                                name : item.response?.data ? item.response.data.name: item.response?.name,
                                md5: item.response?.data ? item.response.data.md5: item.response?.md5,
                                _id: item.response?.data ? item.response.data._id: item.response?._id,
                                isChunk : true,
                            }
                        })
                        setFilesList(fileListTemp);
                    }}
                >
                    <div ref={uploadRef} style={{display: "none"}}></div>
                </Upload>
                <style>
                    {
                        " #batchEntryContent > span { display: none;}"
                    }
                </style>
            </div>
        </Modal>
    );

    const close = () => {
        setVisible(false);
    }

    const fileCancel = (file) => {
        chunkUpload.cancelUpload(file);
        fileDelete(file);
    }

    const fileDelete = (file)=>{
        const fileListTemp = [...filesList];
        const finalFileList = fileListTemp.filter(item=>{
            if (file.uid) {
                return item.uid !== file.uid
            }else if(file.md5) {
                return item.md5 !== file.md5
            }
            return false
        })
        setFilesList(finalFileList);
    }

    // word批量导入接口
    const batchImport = (params) => {
        if (!filesList.length) {
            message.destroy();
            message.warning("请添加要录入的文件");
            return;
        }
        if (filesList.some(item=>item.status !== "done"||!item.url)) {
            message.destroy();
            message.warning("请等待文件上传结束");
            return;
        }
        request({
            url: "/cm-sites-media-consumer/position/handler/wordBatchInput",
            method: "post",
            body: params,
            contentType: "json",
            callBack: (response)=>{
                if (response) {
                    if (Array.isArray(response.errorList)&&response.errorList.length) {
                        message.warning(`${response.errorList.join(",")}上传失败`);
                    }else{
                        message.success("上传成功");
                    }
                }
                typeof props.reload === 'function' && props.reload();
                close();
            },
            errorCallBack:(error)=>{
                message.error(error)
            }
        })
    }

    return (
        <>
            <span onClick={()=>setVisible(true)}>批量录入</span>
            {renderModal}
        </>
    )
}
export default memo(BatchEntry);